import BaseTool from "./base/BaseTool";
import { getEnabledElement } from "component/toolManager/enabledElements.js";
import Helper from "helper";

/**
 * 선 그리기
 * @TODO  Canvas 그리기 편의 함수는 추후 Canvas Context 클래스에 위치
 * @param {*} context     canvas context
 * @param {*} startPoint  선 시작점
 * @param {*} endPoint    선 끝점
 * @param {*} config      추가 그리기 정보
 */
function drawLine(context, startPoint, endPoint, config) {
  context.moveTo(startPoint.x, startPoint.y);
  context.lineTo(endPoint.x, endPoint.y);
}

function drawVerticalScalebarIntervals(context, config) {
  for (let i = 0; i < config.numOfMinorTick + 1; i++) {
    const startPoint = {
      x: config.verticalLine.start.x,
      y: config.verticalLine.start.y + i * config.verticalMinorTick,
    };

    const endPoint = {
      x: 0,
      y: config.verticalLine.start.y + i * config.verticalMinorTick,
    };

    if (i % config.numOfMinorTick === 0) {
      endPoint.x = config.verticalLine.start.x + config.majorTickLength;
    } else {
      endPoint.x = config.verticalLine.start.x + config.minorTickLength;
    }

    drawLine(context, startPoint, endPoint, config);
  }
}

function drawHorizontalScalebarIntervals(context, config) {
  for (let i = 0; i < config.numOfMinorTick + 1; i++) {
    const startPoint = {
      x: config.horizontalLine.start.x + i * config.horizontalMinorTick,
      y: config.horizontalLine.start.y,
    };

    const endPoint = {
      x: config.horizontalLine.start.x + i * config.horizontalMinorTick,
      y: 0,
    };

    if (i % config.numOfMinorTick === 0) {
      endPoint.y = config.horizontalLine.start.y - config.majorTickLength;
    } else {
      endPoint.y = config.horizontalLine.start.y - config.minorTickLength;
    }
    drawLine(context, startPoint, endPoint, config);
  }
}

function drawVerticalScalebar(context, config) {
  const startPoint = {
    x: config.verticalLine.start.x,
    y: config.verticalLine.start.y,
  };
  const endPoint = {
    x: config.verticalLine.end.x,
    y: config.verticalLine.end.y,
  };

  // context.beginPath();
  // context.strokeStyle = config.color;
  // context.lineWidth = config.lineWidth;

  drawLine(context, startPoint, endPoint, config);
  drawVerticalScalebarIntervals(context, config);

  context.stroke();
}

function drawHorizontalScalebar(context, config) {
  const startPoint = {
    x: config.horizontalLine.start.x,
    y: config.horizontalLine.start.y,
  };
  const endPoint = {
    x: config.horizontalLine.end.x,
    y: config.horizontalLine.end.y,
  };

  drawLine(context, startPoint, endPoint, config);
  drawHorizontalScalebarIntervals(context, config);
}

function drawScalebars(context, config) {
  context.shadowColor = config.shadowColor;
  context.shadowBlur = config.shadowBlur;
  context.strokeStyle = config.color;
  context.lineWidth = config.lineWidth;

  context.beginPath();
  drawHorizontalScalebar(context, config);
  context.closePath();
  context.stroke();

  context.beginPath();
  drawVerticalScalebar(context, config);
  context.closePath();
  //context.stroke();
}

// // Computes the max bound for scales on the image
// function computeScaleBounds(
//   eventData,
//   canvasSize,
//   imageSize,
//   horizontalReduction,
//   verticalReduction
// ) {
//   let canvasBounds = {
//     left: 0,
//     top: 0,
//     width: canvasSize.width,
//     height: canvasSize.height,
//   };

//   const hReduction = horizontalReduction * Math.min(1000, canvasSize.width);
//   const vReduction = verticalReduction * Math.min(1000, canvasSize.height);
//   canvasBounds = {
//     left: canvasBounds.left + hReduction,
//     top: canvasBounds.top + vReduction,
//     width: canvasBounds.width - 2 * hReduction,
//     height: canvasBounds.height - 2 * vReduction,
//   };

//   return {
//     topLeft: {
//       x: canvasBounds.left,
//       y: canvasBounds.top,
//     },
//     bottomRight: {
//       x: canvasBounds.left + canvasBounds.width,
//       y: canvasBounds.top + canvasBounds.height,
//     },
//   };
// }

class ScaleOverlayTool extends BaseTool {
  constructor(props = {}) {
    const defaultProps = {
      name: "ScaleOverlayTool",
      mixins: ["enabledOrDisabledBinaryTool"],
      configuration: {
        color: "rgba(255,255,255,0.6)",
        numOfMinorTick: 10,
        lineWidth: 1,
        shadowColor: "black",
        shadowBlur: 4,
      },
    };
    //super(props, defaultProps);
    const initialConfiguration = Object.assign(defaultProps, props);

    super(initialConfiguration);

    this.initialConfiguration = initialConfiguration;
    this.orientation = 0;
  }

  async enabledCallback(element, { synchronizationContext } = {}) {
    const renderer = this.configuration.renderer;
    const enabledElement = getEnabledElement(element);

    if (!enabledElement || !renderer || !synchronizationContext) {
      // Helper.Except.warn(
      //   "Unable to get enabledElement. Existing enable callback. Tool will be enabled, but will not render."
      // );
      return;
    }

    this.forceImageUpdate(element);
  }

  disabledCallback(element) {
    this.forceImageUpdate(element);
  }

  forceImageUpdate(element) {
    const enabledElement = getEnabledElement(element);
    if (enabledElement.image) {
      enabledElement.needsRedraw = true;
    }
  }

  getVariableAttributeSize(canvasSize) {
    let varAttrs = {
      thickness: 3,
      majorTickLength: 10,
      minorTickLength: 5,
      //margin: 20,
      //hMargin: 20,
      hMargin: 15,
      vMargin: 20,
    };

    if (Helper.Validator.isObject(canvasSize) === false) {
      Helper.Except.throw(
        "getVarriableAttributeSize : canvasSize is not object"
      );
      return varAttrs;
    }

    if (
      Helper.Validator.isDefined(canvasSize) === false ||
      Helper.Validator.isDefined(canvasSize.width) === false ||
      Helper.Validator.isDefined(canvasSize.height) === false
    ) {
      Helper.Except.throw(
        "getVarriableAttributeSize : canvasSize has not width or height"
      );
      return varAttrs;
    }

    if (canvasSize.width > 800) {
      varAttrs.thickness = 3;
      varAttrs.majorTickLength = 10;
      varAttrs.minorTickLength = 5;
      //varAttrs.hMargin = 30;
      varAttrs.hMargin = 20;
      //varAttrs.vMargin = 20;
      varAttrs.vMargin = 13;
    } else if (canvasSize.width > 400) {
      varAttrs.thickness = 2;
      varAttrs.majorTickLength = 5;
      varAttrs.minorTickLength = 2.5;
      //varAttrs.hMargin = 25;
      varAttrs.hMargin = 15;
      //varAttrs.vMargin = 15;
      varAttrs.vMargin = 8;
    } else {
      varAttrs.thickness = 1;
      varAttrs.majorTickLength = 2.5;
      varAttrs.minorTickLength = 1.2;
      //varAttrs.margin = 12;
      //varAttrs.hMargin = 20;
      varAttrs.hMargin = 12;
      //varAttrs.vMargin = 12;
      varAttrs.vMargin = 6;
    }

    return varAttrs;
  }

  renderToolData(evt) {
    const eventData = evt.detail;

    // Check whether pixel spacing is defined
    const pixelSpacing = eventData.image.pixelSpacing;
    const hasPixelSpacing = eventData.image.isExistPixelSpacing;
    //const hasPixelSpacing = Helper.Validator.isDefined(pixelSpacing);
    if (hasPixelSpacing === false) {
      return;
    }
    const rowPixelSpacing = pixelSpacing[0];
    const columnPixelSpacing = pixelSpacing[1];
    if (!rowPixelSpacing || !columnPixelSpacing) {
      return;
    }
    let enabledElement = getEnabledElement(eventData.element);
    const viewport = enabledElement.viewport;
    if (!viewport) {
      return;
    }

    const canvasSize = {
      width: enabledElement.canvas.width,
      height: enabledElement.canvas.height,
    };
    const imageSize = {
      width: enabledElement.image.width || enabledElement.image.columns,
      height: enabledElement.image.height || enabledElement.image.rows,
    };

    /**
     * @FIXME : Row/Colume Pixelspacing이 다른 경우, 렌더링 옵션에 따라
     * 추가 스케일 계산이 포함됨.
     * ScaleOverlayTool 도 추가 스케일 계산과 동일한 연산이 동반되어야함.
     * calculateTransform() 함수로 수행되며, 이에 대한 연산은 일률적으로 수행될 수 있도록
     * 수정 필요
     */
    let widthScale = enabledElement.viewport.scale;
    let heightScale = enabledElement.viewport.scale;
    if (rowPixelSpacing < columnPixelSpacing) {
      widthScale *= columnPixelSpacing / rowPixelSpacing;
    } else if (columnPixelSpacing < rowPixelSpacing) {
      heightScale *= rowPixelSpacing / columnPixelSpacing;
    }

    // Distance between intervals is 10mm
    // const verticalIntervalScale = (10.0 / rowPixelSpacing) * viewport.scale;
    // //const horizontalIntervalScale = (10.0 / rowPixelSpacing) * viewport.scale;
    // const horizontalIntervalScale =
    //   (10.0 / columnPixelSpacing) * viewport.scale;

    const verticalIntervalScale = (10.0 / rowPixelSpacing) * heightScale;
    //const horizontalIntervalScale = (10.0 / rowPixelSpacing) * viewport.scale;
    const horizontalIntervalScale = (10.0 / columnPixelSpacing) * widthScale;

    const variableAttrs = this.getVariableAttributeSize(canvasSize);

    if (
      !canvasSize.width ||
      !canvasSize.height ||
      !imageSize.width ||
      !imageSize.height
    ) {
      return;
    }

    const verticalLineMiddlePoint = {
      x: variableAttrs.vMargin,
      y: canvasSize.height / 2,
    };
    const horizontalLineMiddlePoint = {
      x: canvasSize.width / 2,
      y: variableAttrs.hMargin,
    };

    const config = {
      verticalMinorTick: verticalIntervalScale,
      horizontalMinorTick: horizontalIntervalScale,
      verticalLine: {
        start: {
          x: verticalLineMiddlePoint.x,
          y:
            verticalLineMiddlePoint.y -
            (this.configuration.numOfMinorTick / 2.0) * verticalIntervalScale,
        },
        end: {
          x: verticalLineMiddlePoint.x,
          y:
            verticalLineMiddlePoint.y +
            (this.configuration.numOfMinorTick / 2.0) * verticalIntervalScale,
        },
      },
      horizontalLine: {
        start: {
          x:
            horizontalLineMiddlePoint.x -
            (this.configuration.numOfMinorTick / 2.0) * horizontalIntervalScale,
          y: canvasSize.height - horizontalLineMiddlePoint.y,
        },
        end: {
          x:
            horizontalLineMiddlePoint.x +
            (this.configuration.numOfMinorTick / 2.0) * horizontalIntervalScale,
          y: canvasSize.height - horizontalLineMiddlePoint.y,
        },
      },
      ...variableAttrs,
      ...this.configuration,
    };

    const context = enabledElement.canvas.getContext("2d");
    context.setTransform(1, 0, 0, 1, 0, 0);
    context.save();

    drawScalebars(context, config);
    context.restore();
  }
}

// Module exports
export default ScaleOverlayTool;
